import { css } from 'lit'

const cardGlobalStyles = css`
  .card {
    background: var(--white);
    border-radius: var(--secondary-border-radius);
    padding: 8px;
    display: flex;
    flex-direction: column;
  }
`

export default cardGlobalStyles
